module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Loading-13a87a1ae8000dfa48995ba483731a7b99ffef40566ccb01ec5c5b47ca89a3c9.svg";